module.exports = __webpack_public_path__ + "static/media/HCMM892.ebc089dc.jpg";